import { Component } from '@angular/core';

@Component({
  selector: 'app-sidebar-footer',
  templateUrl: './app-sidebar-footer.component.html'
})
export class AppSidebarFooterComponent { }



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/app/components/app-sidebar-footer/app-sidebar-footer.component.ts